module.exports = __webpack_public_path__ + "img/events-white.f5659a1.png";